export default "__VITE_ASSET__a554e027__"